export const CustomeStyle = {
  headerText:
    "text-black font-bold text-xl sm:text-1xl md:text-1xl lg:text-1xl line-clamp-3",
  text: "text-gray-600  text-xss sm:text-sm md:text-s text-black font-bold",
  smalltext:
    "text-black mb-1 text-[12px] sm:text-[15px] md:text-[15px] lg:text-[14px]",
  description:
    "text-black mb-1 text-[12px] sm:text-[15px] md:text-[15px] lg:text-[14px] line-clamp-2 ",
  descriptionOneLine:
    "text-black mb-1 text-[12px] sm:text-[15px] md:text-[15px] lg:text-[14px] line-clamp-1",
  title: "text-black  text-xss sm:text-sm md:text-base text-black font-bold",
  row: "flex row-flex",
  container:
    "w-[90%] items-center mx-auto bg-white border border-gray-300  p-3 mb-10",
  box: "w-[30%] items-center mx-auto bg-gray-50 border border-black-300 shadow-lg p-2 ",
  button:
    "text-blue-600  border-2 border-gray-100 shadow-md p-1.5 px-4 rounded-lg ",
  Addbutton: "text-white gray-100 shadow-md p-2 px-7 rounded-lg bg-orange-400",
  BuyNowbutton: "text-white gray-100 shadow-md p-2 px-5 rounded-lg bg-red-500",
  inputBox:
    "block w-full p-1 mb-4 text-lg border-2 border-gray-300 rounded-xl bg-gray-50",
  textBlack:
    "text-black  text-xss sm:text-sm md:text-base  font-bold line-clamp-2 w-[90%]",
  OnetextBlack:
    "text-black  text-xss sm:text-sm md:text-base text-black font-bold text-center",
  OneLineText:
    "text-black  text-xs sm:text-sm md:text-base text-black font-medium line-clamp-1",
};
